export default "__VITE_ASSET__B$klEDb9__"